import { isSupabaseConfigured } from "@/lib/env";
import { supabase } from "@/lib/supabase";
import { getPqrAttachmentFileName } from "@/features/pqr/pqrMappers";
import {
  pqrAttachmentSignedUrlExpirySeconds,
  type PqrAttachmentLink,
} from "@/features/pqr/pqr.types";

export const PQR_ATTACHMENTS_BUCKET = "pqr-attachments";

function ensureConfigured() {
  if (!isSupabaseConfigured()) {
    throw new Error("Supabase environment variables are not configured.");
  }
}

export async function createPqrAttachmentSignedLinks(
  attachmentPaths: string[],
): Promise<PqrAttachmentLink[]> {
  ensureConfigured();

  const results = await Promise.all(
    attachmentPaths.map(async (path) => {
      const { data, error } = await supabase.storage
        .from(PQR_ATTACHMENTS_BUCKET)
        .createSignedUrl(path, pqrAttachmentSignedUrlExpirySeconds);

      if (error || !data?.signedUrl) {
        throw error ?? new Error("Could not create a signed PQR attachment URL.");
      }

      return {
        fileName: getPqrAttachmentFileName(path),
        path,
        signedUrl: data.signedUrl,
      } satisfies PqrAttachmentLink;
    }),
  );

  return results;
}
